module.exports = __webpack_public_path__ + "assets/amazon.fea38bbf.svg";